/** @format */

import React from "react";
import Icons from "./ui/Icons";

const ModalHeader = ({ title, onClick, filterElem }) => {
  return (
    <header className="flex-k js-between-k">
      <div className="flex-k w-full-k items-center-k js-between-k">
        {title ? (
          <h4 className="bold-text fs-large-k dark-text">{title}</h4>
        ) : null}
        {filterElem ? filterElem : null}
        <button
          className="btn-k rounded-full-k btn-muted-k small"
          onClick={onClick}
        >
          <Icons name={"cross"} size={25} />
        </button>
      </div>
    </header>
  );
};

export default ModalHeader;
